import { render, staticRenderFns } from "./ChineseLevel.vue?vue&type=template&id=6562d9cc&scoped=true&"
import script from "./ChineseLevel.vue?vue&type=script&lang=js&"
export * from "./ChineseLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6562d9cc",
  null
  
)

export default component.exports